import Switch from "@mui/material/Switch";
import { COLORS } from "@styles";

const sx = {
  width: '3rem',
  height: '2rem',
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: COLORS.NEUTRAL_WHITE,
      '& + .MuiSwitch-track': {
        background: `linear-gradient(27deg, ${COLORS.GRADIENT_BLUE_NEUTRAL} 13.94%, ${COLORS.GRADIENT_BLUE_CYAN} 91.13%)`,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
      '& .MuiSwitch-thumb': {
        width: '1.5rem',
        height: '1.5rem',
        margin: '0.25rem',
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: COLORS.ELEKTRAFI_NEUTRAL,
      border: `6px solid ${COLORS.NEUTRAL_WHITE}`,
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: COLORS.NEUTRAL_LIGHT_3,
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 0.7,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '1rem',
    height: '1rem',
    margin: '0.5rem 0.25rem',
    backgroundColor: COLORS.NEUTRAL_WHITE,
  },
  '& .MuiSwitch-track': {
    borderRadius: '1.25rem',
    backgroundColor: COLORS.NEUTRAL_DARK_1,
    opacity: 1,
  },
};

interface CustomSwitchProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

export function CustomSwitch({ checked, onChange, disabled = false }: CustomSwitchProps) {
  return (
    <Switch
      sx={sx}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
  )
}